// extracted by mini-css-extract-plugin
module.exports = {"details":"IndicatorDetails_details_2-qOg"};